import { lazy } from 'react';
const PrevencionPage = lazy(() => import('../../pages/PrevencionPage'));

const prevencionPath = [
  'prevencion/objetivos',
  'prevencion/cesacion-tabaquica',
  'prevencion/diabetes',
  'prevencion/embarazo-saludable',
  'prevencion/epoc',
  'prevencion/insuficiencia_cardiaca',
  'prevencion/re-educacion-alimentaria',
  'prevencion/charlas-comunidad',
  'prevencion/ciclo-actividades',
  'prevencion/guias-prevencion',
];

const preventionRoutes = prevencionPath.map((path) => ({
  title: 'Prevención',
  path,
  component: PrevencionPage,
  isPrivate: false,
}));

export default preventionRoutes;
